import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { UserNote, NOTES_WIDGET_ENABLED_KEY } from '../models/note.model';

@Injectable({ providedIn: 'root' })
export class NoteService {
  private readonly API_URL = `${environment.apiUrl}/notes`;
  private http = inject(HttpClient);

  getNotes(): Observable<UserNote[]> {
    return this.http.get<UserNote[]>(this.API_URL);
  }

  createNote(text: string, color: string): Observable<UserNote> {
    return this.http.post<UserNote>(this.API_URL, { text, color, isPinned: false });
  }

  updateNote(id: number, changes: Partial<Pick<UserNote, 'text' | 'color' | 'isPinned'>>): Observable<UserNote> {
    return this.http.put<UserNote>(`${this.API_URL}/${id}`, changes);
  }

  deleteNote(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`, { responseType: 'text' as 'json' });
  }

  isWidgetEnabled(): boolean {
    const val = localStorage.getItem(NOTES_WIDGET_ENABLED_KEY);
    return val === null ? true : val === 'true';
  }

  setWidgetEnabled(enabled: boolean): void {
    localStorage.setItem(NOTES_WIDGET_ENABLED_KEY, String(enabled));
  }
}
